import {FluentProvider, makeStyles, Theme, webDarkTheme, webLightTheme} from "@fluentui/react-components";
import AdminRouter from "./admin/AdminRouter";
import {Route, Routes} from "react-router-dom";
import HomePage from "./HomePage";
import SuccessPage from "./mission/common/SuccessPage";
import {ErrorPage} from "./mission/common/ErrorPage";
import {useError, useStatePair} from "../type/States";
import {useEffect} from "react";
import {FailurePage} from "./mission/common/FailurePage";
import AccessDeniedPage from "./mission/common/AccessDeniedPage";
import FinishPage from "./mission/common/Finish";
import ParticipationCntFullPage from "./mission/common/ParticipationCntFullPage";
import TestPage from "./mission/common/Test";

const useStyles = makeStyles({
    provider: {
        display: 'inline-block',
        minWidth: '100vw',
        fontSize:'medium'
    },
    root: {
        display: 'inline-block',
        minHeight: '100vh',
    }
})

function getThemeFromStorage(): Theme {
    if (localStorage.getItem('isDark') === 'true') {
        return webDarkTheme
    } else  {
        return webLightTheme
    }
}

function setThemeIntoStorage(theme: Theme) {
    if (theme === webDarkTheme) {
        localStorage.setItem('isDark', 'true');
    } else {
        localStorage.removeItem('isDark');
    }
}

export default function RootRouter() {
    const styles = useStyles()
    const themeState = useStatePair<Theme>(webLightTheme)
    const missionErrorState = useError()

    useEffect(() => {
        setThemeIntoStorage(themeState.value)
    }, [themeState.value]);

    return <>
        <FluentProvider theme={themeState.value} className={styles.provider}>
            <missionErrorState.Dialog
                themeState={themeState}/>
            <Routes>
                <Route path="/" element={<HomePage themeState={themeState}/>}/>
                <Route path="/success" element={<SuccessPage/>}/>
                <Route path="/finish" element={<FinishPage/>}/>
                <Route path="/error" element={<ErrorPage/>}/>
                <Route path="/failure" element={<FailurePage/>}/>
                <Route path="/accessDenied" element={<AccessDeniedPage/>}/>
                <Route path="/limit" element={<ParticipationCntFullPage/>}/>
                <Route path="/test" element={<TestPage/>}/>
                <Route path="/admin/*" element={<AdminRouter/>}/>
            </Routes>
        </FluentProvider>
    </>
}